/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
  const STAR_SIZE = 12; // ← change this to resize stars (in pixels)

  function createFullStarSvg() {
    const svgns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgns, "svg");
    svg.setAttribute('width', String(STAR_SIZE));
    svg.setAttribute('height', String(STAR_SIZE));
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'black');
    svg.setAttribute('stroke', 'none');
    svg.style.verticalAlign = 'middle';
    const path = document.createElementNS(svgns, "path");
    path.setAttribute('d', 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.9L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01L12 2z');
    svg.appendChild(path);
    return svg;
  }

  function createHalfStarSvg() {
    const svgns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgns, "svg");
    svg.setAttribute('width', String(STAR_SIZE));
    svg.setAttribute('height', String(STAR_SIZE));
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'black');
    svg.setAttribute('stroke', 'none');
    svg.style.verticalAlign = 'middle';
    svg.style.transform = 'scaleX(-1)'; // mirror the right-half path
    const path = document.createElementNS(svgns, "path");
    path.setAttribute('d', 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.9L12 17.77V2z');
    svg.appendChild(path);
    return svg;
  }

  const ratingElements = document.querySelectorAll('.rasinProductRating');

  ratingElements.forEach(ratingElement => {
    const textContent = ratingElement.textContent || '';
    const match = textContent.match(/\d+(\.\d+)?/);

    if (!match) return;

    const ratingValue = parseFloat(match[0]);
    const fullStars = Math.floor(ratingValue);
    const remainder = ratingValue - fullStars;
    const hasHalfStar = remainder >= 0.25 && remainder <= 0.75;

    // Clear existing contents
    ratingElement.textContent = '';

    // Insert full stars
    for (let i = 0; i < fullStars; i++) {
      ratingElement.appendChild(createFullStarSvg());
    }

    // Insert half star if needed
    if (hasHalfStar) {
      ratingElement.appendChild(createHalfStarSvg());
    }

    // Append the numeric rating with conditional spacing
    const ratingNumber = document.createElement('span');
    ratingNumber.textContent = String(ratingValue);
    if (!hasHalfStar) {
      ratingNumber.style.marginLeft = '3px';
    }
    ratingElement.appendChild(ratingNumber);
  });
});


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
